import React, { ChangeEvent, useCallback, useRef, useState } from 'react';
import ModalAppointment from '../ModalAppointment.tsx';
import { AppointmentDate, AppointmentSteps, AppointmentTypes, ModalObj } from "../../Models/Types.ts"
import { parseDate } from '../../Utils/StringFunctions.ts';
import Loader from '../../Components/UI/Loader.tsx';
import { AppointmentRequest, AppointmentRequestBase, RemoteAPI } from '../../appointmentApi.tsx';
import InputField from '../../Components/UI/InputField.tsx';
import Dialog from '@mui/material/Dialog';
import IntlTelInput, { IntlTelInputRef } from 'intl-tel-input/react';

const RequestAppointment = () => {

  const [visibleInput, setVisibleInput] = useState<string>("")

  const [visibleLoading, setVisibleLoading] = useState<boolean>(false)

  const [selectedStep, setSelectedStep] = useState<AppointmentSteps>(AppointmentSteps.TYPE_VIEW);

  const [sendingData, setSendingData] = useState<boolean>(false);

  const [showModal, setShowModal] = useState<ModalObj>({ show: false, text: "", onClose: () => { } })

  const [visibleModal, setVisibleModal] = useState<boolean>(false)

  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState<AppointmentDate | null>(null)

  const [selectedAppointmentType, setSelectedAppointmentType] = useState<AppointmentTypes | null>(null)

  const [appointmentRequestForm, setAppointmentRequestForm] = useState<AppointmentRequest>(AppointmentRequest.getEmptyRequest());

  const [privacyChecked, setPrivacyChecked] = useState<boolean>(false);

  const inputPhoneRef = useRef<IntlTelInputRef>(null)

  const onSelectDate = useCallback((appointment: AppointmentDate | null) => {
    setSelectedAppointmentDate(appointment);
    setVisibleModal(false)
  }, [])

  const onChangeAppointmentRequestForm = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setAppointmentRequestForm(old => old ? ({ ...old, [e.target.name]: e.target.value }) : old); //ho dovuto fare così perché old può essere undefined e non è compatibile con l'oggetto AppointmentRequest
  }, [])

  const handleClose = useCallback(() => {
    if (showModal.text === "Richiesta inviata correttamente.") {
      window.location.href = 'https://www.temptation.it';
    } else {
      setShowModal({ show: false, text: ""})
    }
  }, [])
  console.log(appointmentRequestForm)
  const onCreateAppointment = useCallback(async () => {
    setSendingData(true)
    let phone = "";
    if (inputPhoneRef.current) {
      phone = `+${inputPhoneRef.current.getInstance()?.getSelectedCountryData().dialCode}${inputPhoneRef.current?.getInput()?.value}`
    }
    let request: AppointmentRequestBase = JSON.parse(JSON.stringify({ ...appointmentRequestForm, phone: phone })) as AppointmentRequestBase;

    if (selectedAppointmentDate !== null) {
      request.date = selectedAppointmentDate.date;
      request.times = selectedAppointmentDate.slots[0]
    }
    if (selectedAppointmentType !== null)
      request.type = selectedAppointmentType;

    if (request.date === "") {
      setShowModal({ show: true, text: "Scegliere una data per l'appuntamento." })
      setSendingData(false)
      /* alert("Scegliere una data per l'appuntamento."); */
      return;
    }

    if (request.name === "") {
      setShowModal({ show: true, text: "Inserisci Nome." })
       setSendingData(false)
      /* alert("Inserisci Nome.") */
      return;
    }

    if (request.surname === "") {
      setShowModal({ show: true, text: "Inserisci Cognome." })
       setSendingData(false)
      /*  alert("Inserisci Cognome.") */
      return;
    }

    if (request.email === "") {
      setShowModal({ show: true, text: "Inserisci Email." })
       setSendingData(false)
      /* alert("Inserisci Email.") */
      return;
    }

    if (request.event_date === "") {
      setShowModal({ show: true, text: "Inserisci Data evento." })
       setSendingData(false)
      /*       alert("Inserisci Data evento.") */
      return;
    }

    if (request.phone === "" || (request.phone.startsWith("+") && request.phone.length <= 4)) {
      setShowModal({ show: true, text: "Inserisci Numero di Telefono." })
       setSendingData(false)
      /* alert("Inserisci Numero di Telefono.") */
      return;
    }

    if (request.locality === "") {
      /* alert("Inserisci Località.") */
      setShowModal({ show: true, text: "Inserisci Località." })
       setSendingData(false)
      return;
    }

    if (!privacyChecked) {
      setShowModal({ show: true, text: "Accetta la privacy prima di continuare." })
       setSendingData(false)
      /*       alert("Privacy") */
      return;
    }

    console.log("request", request);

    try {
      await RemoteAPI.createAppointment(request);
      // @ts-ignore
      dataLayer.push({'event':'appuntamento'})
      //
      setShowModal({
        show: true, text: "La richiesta di appuntamento è andata a buon fine. Grazie per averci scelto.", onClose: () => {
          setSelectedAppointmentDate(null);
          setSelectedAppointmentType(null);
          setSelectedStep(AppointmentSteps.TYPE_VIEW);
          setAppointmentRequestForm(AppointmentRequest.getEmptyRequest());
          setPrivacyChecked(false)
        }
      })
      setSendingData(false)
    } catch (error) {
      console.log(error);
      setSendingData(false)
      alert("Errore del Server. Contattare l'assistenza.")
    }

    //RemoteAPI.createAppointment();
  }, [appointmentRequestForm, selectedAppointmentDate, selectedAppointmentType, privacyChecked])

  return <>
    <div className="container-header-appointment div-request-appoinment-text">
      <div className="container-header-logo">
        Richiedi appuntamento
      </div>
    </div>

    <div className="container-text-center">
      <div className="text-align-center">
        Contattaci per un appuntamento nel nostro Atelier.
        Verrai accolto dalle nostre consulenti per provare tutti gli abiti che preferisci.
      </div>
    </div>

    <div className="container-form-appointment">

      <div className="container-request-appointment">
        <div className="label-font" style={{ textAlign: "center", fontSize: "30px" }}>
          Online
        </div>
        <div className="container-button-date-appointment">
          <div id="label-button-appointment"></div>
          <button onClick={() => setVisibleModal(true)} id="button-date-appointment" className="button-date-appointment">
            {selectedAppointmentDate === null || selectedAppointmentType === null ?
              <>
                Seleziona data
                <img
                  className="image-calendar" src="/calendario-appuntamenti/images/calendar-clock-icon_34472.webp" />
              </>
              :
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "2vw"
                }}
              >
                <div>
                  <div>Appuntamento {AppointmentTypes.toString(selectedAppointmentType)}</div>
                  <div>{parseDate(selectedAppointmentDate.date)}</div>
                  <div>{selectedAppointmentDate.slots[0].start}</div>
                </div>
                <img className='icon-modify' src='./Assets/pen_edit_icon_177296.webp' />
              </div>
            }

          </button>
        </div>


        {selectedAppointmentDate !== null &&
          <>

            <div className={`row-input show-flex`}>

              <InputField required type="text" placeholder="Nome" name="name" onChange={onChangeAppointmentRequestForm} />
              <InputField required type="text" placeholder="Cognome" name="surname" onChange={onChangeAppointmentRequestForm} />
            </div>
            <div className={`row-input show-flex`}>
              <InputField required type="text" placeholder="Email" name="email" onChange={onChangeAppointmentRequestForm} />
              <div className='input-phone-container'>
                <IntlTelInput
                  ref={inputPhoneRef}
                  initOptions={{
                    initialCountry: "it",
                    separateDialCode: true,
                  }}
                />
              </div>
              {/* <InputField required type="text" placeholder="Telefono" name="phone" onChange={onChangeAppointmentRequestForm} /> */}
            </div>
            <div className={`row-input show-flex`}>
              <InputField required type="text" placeholder="Città" name="locality" onChange={onChangeAppointmentRequestForm} />
            </div>
            <div className={`row-input show-flex`}>
              <div className="container-date-event-input" style={{ width: "46%", position: "relative" }}>
                <div>
                  Data evento
                </div>
                <div>
                  <InputField required aria-placeholder="Data evento" placeholder="Data evento" type="date" name="event_date" onChange={onChangeAppointmentRequestForm} />
                </div>
              </div>
            </div>

            <div className={`row-input show-flex`}>
              <div style={{ width: "100%" }}>
                Richieste specifiche [facoltativo]
                <textarea onChange={e => setAppointmentRequestForm(old => old ? ({ ...old, [e.target.name]: e.target.value }) : old)} name="note" aria-label="Richieste specifiche [facoltativo]"
                  className="date-appointment-note"
                  id="date-appointment-note">
                </textarea>
              </div>
            </div>

            <div className={`container-privacy-policy show-flex`}>
              <div>
                <input id="check-box-policy" type="checkbox" onChange={e => setPrivacyChecked(e.target.checked)} /> Dichiaro di aver letto e di accettare la
                <a style={{ marginLeft: "5px" }} target="_blank"
                  href="https://www.iubenda.com/privacy-policy/33835044">Privacy Policy</a>
              </div>
            </div>
            <div className={`container-button-appointment show-flex`}>
              {sendingData ? <Loader /> : <button id="button-request-appointment" className="button-request-appointment" onClick={onCreateAppointment}> Richiedi
                appuntamento
              </button>}
            </div>
          </>
        }
      </div>
      {visibleModal &&
        <ModalAppointment
          setAppointmentRequestForm={setAppointmentRequestForm}
          setVisibleModal={setVisibleModal}
          onSelectDate={onSelectDate}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          selectedType={selectedAppointmentType}
          setSelectedType={setSelectedAppointmentType}
          appointmentRequestForm={appointmentRequestForm}
        />
      }

      <div className="row-form-appointment">
        <a target="_blank" href="tel:+39096621529" className="tile-form-appoinment">
          <img className="icon" src="/calendario-appuntamenti/images/telephone-handle-silhouette.png" />
          <div className="container-right-tile">
            <div className="label-font">
              Per telefono
            </div>
            <div>
              +39 0966 21529
            </div>
          </div>
        </a>
        <a target="_blank" href="https://wa.me/39096621529" className="tile-form-appoinment">
          <img className="icon" src="/calendario-appuntamenti/images/whatsapp.png" />
          <div className="container-right-tile">
            <div className="label-font">
              Su whatsapp
            </div>
            <div>
              +39 0966 21529
            </div>
          </div>
        </a>
      </div>
    </div>

    <Dialog
      open={showModal.show}
      onClose={() => {
        handleClose();
        if (showModal.onClose) {
          showModal.onClose()
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ padding: "20px" }}>
        {showModal.text}
      </div>
    </Dialog>
  </>
}

export default RequestAppointment